import { useTranslation } from 'react-i18next';
import { CardPocket } from '@/common/components/CardPocket/CardPocket';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { useGetPockets } from '@/common/integrations/menhir/employee/pockets/pockets.hooks';
import { MoneyUtils, defaultMoney } from '@coverflex-tech/hypernova-utils';
import { useRouter } from 'expo-router';

export function ITFringeCardPocket() {
  const router = useRouter();
  const { t } = useTranslation();
  const { fringePocket, isInitialLoading: isLoadingPockets } = useGetPockets();

  return (
    <CardPocket
      title={t('dashboard.home.it.fringe_card.title')}
      icon={<Icon icon="icons" />}
      onPress={() =>
        router.push({
          pathname: ROUTES.WELFARE_BENEFIT,
          params: { slug: 'fringe' },
        })
      }
      values={[
        {
          value: MoneyUtils.moneyToString(
            fringePocket?.balance ?? defaultMoney
          ),
          label: t('dashboard.home.it.fringe_card.description'),
          loading: isLoadingPockets,
        },
      ]}
    />
  );
}
